import { Routes } from "@blitzjs/next"
import MakeItRain from "app/core/components/animation/MakeItRain"
import { SButton } from "@superwall-me/sui"
import Head from "next/head"
import Image from "next/legacy/image"
import { useRouter } from "next/navigation"
import Logo from "public/SuperwallLogo.svg"
import { FC, PropsWithChildren, useState, useEffect } from "react"
import { Button } from "@superwall/ui"

const ErrorLayout: FC<PropsWithChildren<{ title?: string; statusCode?: number }>> = ({
  title,
  statusCode,
  children,
}) => {
  const router = useRouter()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      <Head>
        <title>{statusCode && title ? `${statusCode}: ${title}` : `Error`}</title>
      </Head>
      <main className={`dark:bg-grayscale-darkest flex flex-grow h-[100dvh]`}>
        <MakeItRain />
        <div className="m-auto justify-center w-full sm:w-3/5 lg:w-3/5 xl:1/2">
          <div className="text-center mb-12">
            <div className="text-center mb-6">
              <div className="mb-10 flex justify-center">
                <div style={{ width: "62%" }} className="max-w-[300px]">
                  <Image alt={"logo"} layout="responsive" src={Logo} />
                </div>
              </div>
            </div>
            {children}
            <div className={"flex justify-center"}>
              <Button
                variant="ghost"
                className={`mt-3`}
                onClick={async () => {
                  if (isClient) {
                    window.history.back()
                  }
                }}
              >
                Go Back
              </Button>
            </div>

            {/* Only show auth buttons on client-side to avoid SSR issues */}
            {isClient && (
              <div className={`fixed right-2 top-2 `}>
                <SButton
                  onClick={async () => {
                    window.location.href = "/dashboard"
                  }}
                >
                  Dashboard
                </SButton>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  )
}

export default ErrorLayout
